/**
 * Import angular core component
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

/**
 * Service Import.
 */
import { GetService } from '../../dataservices/get.service';
import { DataStorageService } from '../../dataservices/data-storage.service';

/**
 * constant import
 */
import { NCP_SUB_PRODUCT_CARD_TYPE, NUMBERS, PRODUCT_TYPE_CONSTANT, SCREEN_NAME, ERROR_CODES } from '../../constants/app.constants';
import { NcpProduct, Product } from '../model/ncp.model';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
import { AnalyticsInterface } from '../../analytics-event/analytics.model';
import { AnalyticsEventService } from '../../analytics-event/analytics-event.service';

@Component({
  selector: 'app-game-list',
  templateUrl: './game-list.component.html',
  styleUrls: ['./game-list.component.scss']
})
export class GameListComponent implements OnInit, OnDestroy {
  /**
   * @cardTypeConst defines Card Type constant
   * @ncpId defines a single NCP product Id
   * @notifier$ defines a notifier subject stream to end data streaming
   */
  public ncpDetail: Product;
  private ncpId: number;
  private notifier$ = new Subject();
  public offset = 1;
  private prevOffset: number;
  public isFinished = true;
  public productList: NcpProduct[] = [];
  public numbers = NUMBERS;
  public analyticsData: AnalyticsInterface;
  public sessiontime = { 'start_time': '', 'end_time': '' };
  public screenName = SCREEN_NAME;

  public cardTypeConst = NCP_SUB_PRODUCT_CARD_TYPE;

  /**
   * This is used to hold the error message.
   */
  public errorMessage = '';
  constructor(private getSer: GetService,
              private route: ActivatedRoute,
              private jwtService: JwtDecodeService,
              private fnCollectionService: FunCollectionService,
              private analyticsEventService: AnalyticsEventService,
              private dss: DataStorageService
  ) { }


  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.ncpId = params['ncpId'];
      this.offset = NUMBERS.ONE;
      this.prevOffset = NUMBERS.ZERO;
      this.productList = [];
      if (this.ncpId) {
        this.getNcpDetail();
        this.sendAnalyticEvent();
      }
    });
  }

  onScroll(): void {
    console.log('scroll calling...');
    this.getNcpDetail();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getNcpDetail(): any {
    if (!this.ncpId || (this.offset === NUMBERS.ZERO) || (this.prevOffset === this.offset)) {
      return;
    }
    this.isFinished = false;
    this.getSer.getNcpDetail(this.ncpId, this.offset).
      pipe(
        takeUntil(this.notifier$)
      ).subscribe((response) => {
        this.jwtService.decodeData(response).then(data => {
          this.ncpDetail = data.data;
          if (data.status === NUMBERS.ONE) {
            if (this.ncpDetail.ncp_product.length) {
              this.ncpDetail.ncp_product.forEach(product => {
                this.productList.push({ ...product });
              });
              this.prevOffset = this.offset;
              this.offset = data.data.offset;
            }
          } else if (data.status === NUMBERS.ZERO) {
            this.fnCollectionService.errorHandeler(data);
            if (data.error.code === ERROR_CODES.ERROR_1005) {
              this.errorMessage = data.error.msg;
            }
          }
          this.isFinished = true;
        });
      }, error => {
        this.isFinished = true;
        this.fnCollectionService.errorHandeler(error);
      });
  }
  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    this.notifier$.next();
    this.notifier$.complete();
    this.sessiontime.end_time = new Date().getTime().toString();
    this.analyticsData = {
      'event_name': EVENT_NAME.NCP_SUBTYPE_VISIT,
      'product_type': PRODUCT_TYPE_CONSTANT.NCP,
      'product_type_id': this.ncpId,
      'screen_name': SCREEN_NAME.NCP_SUBTYPE_LISTING_PAGE,
      'start_time': this.sessiontime.start_time,
      'end_time': this.sessiontime.end_time
    };
    this.analyticsEventService.logAnalyticsEvent(this.analyticsData);
  }

  /**
   * @EventHandler for sending analytic event
   */
  sendAnalyticEvent(): void {
    const dateObj = new Date();
    this.sessiontime.start_time = dateObj.getTime().toString();
    const events = [EVENT_NAME.NCP_SUBTYPE_ENTRY];
    for (const event of events) {
      this.analyticsData = {
        'event_name': event,
        'product_type': PRODUCT_TYPE_CONSTANT.NCP,
        'product_type_id': this.ncpId,
        'screen_name': SCREEN_NAME.NCP_SUBTYPE_LISTING_PAGE,
        'start_time': this.sessiontime.start_time,
        'end_time': this.sessiontime.start_time
      };
      this.analyticsEventService.logAnalyticsEvent(this.analyticsData);
    }
  }

}
